import { useEffect } from 'react';

import { getDashboardUrl } from '@/lib/dashboard-url';

/**
 * Redirects to the dashboard app (VITE_DASHBOARD_URL).
 * Used so callers can navigate('/dashboard') instead of window.location.
 */
export function DashboardRedirectPage() {
  useEffect(() => {
    window.location.href = getDashboardUrl();
  }, []);
  return null;
}
